<template>
    <div class="col-lg-6 offset-lg-3 mx-auto mb-5 max-w-[497px] rounded-md legacy-md:p-8 legacy-md:shadow-xl">
        <div class="mb-10">
            <a
                class="btn-link text-sm text-content-secondary hover:text-content-primary focus:text-content-primary"
                href="#"
                tabindex="1"
                @click="backButtonClicked"
                ><font-awesome-icon
                    class="mr-1"
                    :icon="['fas', 'angle-left']"
                />Back</a
            >
        </div>

        <div class="mb-3 mt-5 flex">
            <h3 class="text-left font-inter text-xl font-semibold">Multi-factor security</h3>
        </div>
        <p class="mb-10 text-base">
            Your account requires multi-factor authentication. Your code will be sent to {{ phoneNumber }}.
        </p>

        <div class="mb-5 flex">
            <div class="grow">
                <div class="mb-3">
                    <label class="font-inter text-sm font-normal">How would you like to receive the code?</label>
                    <div class="grid grid-cols-4 gap-6">
                        <div class="col-start-1 col-end-3">
                            <button
                                class="btn btn-brand w-full max-w-full basis-1/2 rounded text-center font-inter text-base font-medium"
                                :disabled="!smsAvailable"
                                tabindex="2"
                                @click="
                                    e => {
                                        e.preventDefault();
                                        currentUserService.requestMFACode(props.getCodeRoute, 'sms');
                                    }
                                "
                            >
                                <font-awesome-icon
                                    class="mr-1"
                                    :icon="['far', 'message-dots']"
                                />
                                Text Me
                            </button>
                        </div>
                        <div class="col-start-3 col-end-5">
                            <button
                                class="btn btn-brand w-full max-w-full basis-1/2 rounded text-center font-inter text-base font-medium"
                                tabindex="3"
                                @click="
                                    e => {
                                        e.preventDefault();
                                        currentUserService.requestMFACode(props.getCodeRoute, 'call');
                                    }
                                "
                            >
                                <font-awesome-icon
                                    class="mr-1"
                                    :icon="['far', 'phone']"
                                />
                                Call Me
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div
                class="col"
                style="text-align: center"
            >
                <p>
                    Need help? Please contact
                    <a
                        v-if="supportEmail"
                        class="btn-link underline"
                        :href="'mailto:' + supportEmail"
                        >{{ supportEmail }}</a
                    >
                    <template v-else>your title company</template>
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useCurrentUserService } from '@/services/current-user.service';
import { ref } from 'vue';

const props = defineProps<{
    getCodeRoute: string;
    smsAvailable: string;
    supportEmail: string | null; // Branch['support_email']
    phoneNumber: string;
}>();

const logoutForm = ref<HTMLFormElement>();
const currentUserService = useCurrentUserService();

function backButtonClicked() {
    logoutForm.value?.submit();
    currentUserService.logout();
}
</script>
